<template>
  <div class="home">
    <!-- First Block -->
    <b-container>
      <b-row>
        <!-- Блок с фото -->
        <b-col class="bg text-center"
               cols="12"
               sm="12"
               md="6"
               lg="6">
          <img alt="RIS"
               src="../assets/1.jpg" />
        </b-col>

        <!-- Блок Feedback -->
        <b-col class="border border-danger py-4 px-5"
               cols="12"
               sm="12"
               md="6"
               lg="6">
          <h1 class="font-weight-bold font-italic">Мы ищем<br /> тебя!</h1>

          <p class="font-italic">Стань частью команды сети ресторанов РИС в городе Сочи</p>

          <span class="text-primary font-weight-bold font-italic">
            Открыты вакансии:
          </span>

          <h4 class="font-weight-bold font-italic">
            Официант, суши-повар, технический персонал, хостес, повар холодного и горячего цеха
          </h4>

          <p class="font-italic">Рассматриваем кандидатов без опыта работы.</p>

          <a href="tel:+79045057838"
             class="btn btn-primary font-weight-bold w-100"
          >
            Свяжись с нами: +7 (904) 505-78-38
          </a>
        </b-col>
      </b-row>
    </b-container>
    <!-- /First Block -->

    <!-- Преимущества -->
    <b-container class="my-5 mx-auto">
      <b-card-group deck>
        <b-card
          border-variant="primary"
          align="center"
        >
          <b-card-text class="font-weight-bold">
            Зарплата до 45.000 рублей каждую неделю
          </b-card-text>
        </b-card>

        <b-card
          border-variant="primary"
          align="center"
        >
          <b-card-text class="font-weight-bold">
            Обучение и наставничество
          </b-card-text>
        </b-card>

        <b-card
          border-variant="primary"
          align="center"
        >
          <b-card-text class="font-weight-bold">
            Рядом с домом
          </b-card-text>
        </b-card>

        <b-card
          border-variant="primary"
          align="center"
        >
          <b-card-text class="font-weight-bold">
            Бесплатное питание
          </b-card-text>
        </b-card>
      </b-card-group>
    </b-container>
    <!-- /Преимущества -->

    <!-- Feedback -->
    <b-container>
      <Feedback />
    </b-container>
    <!-- /Feedback -->

    <!-- ModalPrivacy -->
    <ModalPrivacy />
    <!-- /ModalPrivacy -->
  </div>
</template>

<script>
import Feedback from '../components/Feedback';
import ModalPrivacy from '../components/ModalPrivacy';

export default {
  name: 'home',
  components: {
    Feedback, ModalPrivacy,
  },
  data () {
    return {};
  },
  mounted: function () {},
  computed: {},
  methods: {},
}
</script>

<style scoped lang="scss">
  .home {
    .bg {
      img {
        width: 80%;
      }
    }
  }

  @media screen and (max-width: 767px) {}
</style>
